import { http } from '@pendo/http';

export function updateUserMetadata (kind, group, payload) {
    return http.post(`/api/s/_SID_/metadata/${kind}/${group}/value`, payload);
}

export function fetchUser (kind, userId, abortSignal) {
    // parentAccounts use same endpoint as account
    if (kind === 'parentAccount') {
        kind = 'account';
    }

    if (typeof userId === 'number') userId = JSON.stringify(userId);
    const isForeignChar = userId.match(/[^A-Za-z0-9 !@#$%^&*()|+=\-_{}\][\\:;'"<>,./?\n]/g);
    const containsXSS = userId.match(/[<>]/g);
    const shouldEncode = !isForeignChar || containsXSS;

    if (shouldEncode) userId = encodeURIComponent(userId);

    return http.get(`/api/s/_SID_/${kind}/${userId}`, { signal: abortSignal });
}
